import React, { createContext } from 'react';
import { RequiredDocumentDTO } from '../../api/useRequiredDocsQuery';

export interface UploadedDocument extends RequiredDocumentDTO {
  snapId: string;
  fileName: string;
}

export interface UploadedDocumentsState {
  primaryApplicant: UploadedDocument[];
  secondaryApplicant: UploadedDocument[];
}

export interface AppealContextValue {
  uploadedDocuments: UploadedDocumentsState;
  addUploadedDocument: (document: UploadedDocument, isSecondaryApplicant?: boolean) => void;
  removeUploadedDocument: (documentType: string, isSecondaryApplicant?: boolean) => void;
}

export const AppealContext = createContext<AppealContextValue | undefined>(undefined);

interface Props {
  value: AppealContextValue;
  children: React.ReactNode;
}

export const AppealContextProvider = ({ children, value }: Props) => (
  <AppealContext.Provider value={value}>{children}</AppealContext.Provider>
);
